import React from 'react';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';

export const ShoppingCartIcon = () => {
    const { isInitialized, items } = useSelector((state) => state.cart);
    const itemsCount = items.reduce((count, item) => count + Number(item.quantity), 0);

    return (
        <div className="me-2">
            <NavLink to="/cart" className="fa-2x">
                <span className="fa-layers fa-fw">
                    <i
                        className="fal fa-shopping-cart"
                        style={{ color: 'var(--bs-secondary)' }}></i>
                    {isInitialized && itemsCount > 0 && (
                        <span
                            className="fa-layers-counter fa-lg"
                            style={{ background: 'var(--bs-red)' }}>
                            {itemsCount}
                        </span>
                    )}
                </span>
            </NavLink>
        </div>
    );
};
